<roots-page-header
  [toolTip]="toolTip"
  [title]="title"
  [loading]="loading"
  [items]="actionButtons"
  (refresh)="refresh()"
  (actionListClicked)="actionsClicked($event)"
>
</roots-page-header>